import { type Brand, make } from 'ts-brand';

/** Shape of the {@link ChatsCredentials} model. */
type ChatsCredentialsShape = Readonly<{

  /** Access token. */
  accessToken: string;
}>;

/** Chats credentials. */
export type ChatsCredentials = Brand<ChatsCredentialsShape, 'ChatsCredentials'>;

/** Chats credentials constructor. */
export const makeChatsCredentials = make<ChatsCredentials>();
